/**
 * The Routes page's view vocabulary — the values `?view=` can take, and the predicates that
 * classify them. The header control that used to live here is now `ViewSelect`.
 */
export enum TopMenuView {
  UNSCHEDULED = 'unscheduled',
  SCHEDULED = 'scheduled',
}

export enum View {
  MAP = 'map',
  UNSCHEDULED_LIST = 'unscheduled-list',
  UNSCHEDULED_TABLE = 'unscheduled-table',
  SCHEDULED_LIST = 'scheduled-list',
  TIMELINE = 'timeline',
  ORDER_DETAILS = 'orderDetails',
  ROUTE_DETAILS = 'routeDetails',
}

export const isScheduledView = (view: View | null) => view && [View.SCHEDULED_LIST, View.TIMELINE].includes(view);

export const isUnscheduledView = (view: View | null) => view && [View.UNSCHEDULED_LIST, View.UNSCHEDULED_TABLE].includes(view);
